module.exports = __webpack_public_path__ + "static/board-11-ebf08a20f70031048594b0115677857b.jpg";